import { FONT, FontStyleSheet } from '../font-style-sheets';
import { PrintCardMenu } from './print-card-menu';

export class MissJonesPrintCardMenu extends PrintCardMenu {
  whatFontsAreNeededToRenderContent(): FontStyleSheet[] {
    return [FONT.Oswald.SemiBold_600, FONT.FuturaPt.Regular_400, FONT.RamaGothicM.SemiBold_600];
  }

  override getAdobeFontFamilyCssUrl(): string | null {
    return 'https://use.typekit.net/kpc2uwj.css';
  }

  shouldStandardizeDominantStrainType(): boolean {
    return false;
  }
}
